// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__abxEZ","icon":"SortAdornment_icon__23Np0","up":"SortAdornment_up__3kiEj","down":"SortAdornment_down__2SF0v","active":"SortAdornment_active__1Yy8D"};